import { useSelector } from 'react-redux';

/**
 * Custom hook to easily access subscription state
 * Usage: const { isFreePlan, isTrialPlan, service_name } = useSubscription();
 */
export const useSubscriptionData = () => {
    return useSelector((state) => state.subscription.subscriptionData);
};

/**
 * Hook to get only isFreePlan
 */
export const useIsFreePlan = () => {
    return useSelector((state) => state.subscription.isFreePlan);
};

/**
 * Hook to get only isTrialPlan
 */
export const useIsTrialPlan = () => {
    return useSelector((state) => state.subscription.isTrialPlan);
};


